import loadGoogleMapsApi from 'load-google-maps-api';

export default class GoogleMap {
  init() {
    const newMap = $el => {
      const $markers = $el.siblings('.google-map__marker');

      const args = {
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
      };

      // create map
      const map = new google.maps.Map($el[0], args);

      // add a markers reference
      map.markers = [];

      // add markers
      $markers.each((i, elm) => {
        addMarker($(elm), map);
      });

      // center map
      centerMap(map);

      // return
      return map;
    };

    // Add marker

    const addMarker = ($marker, map) => {
      const latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

      // create marker
      const marker = new google.maps.Marker({
        position: latlng,
        map: map,
      });

      // add to array
      map.markers.push(marker);

      // if marker contains HTML, add it to an infoWindow
      if($marker.html()) {
        // create info window
        const infowindow = new google.maps.InfoWindow({
          content: $marker.html(),
        });

        // show info window when marker is clicked
        google.maps.event.addListener(marker, 'click', function() {
          infowindow.open(map, marker);
        });
      }
    };

    // Center map

    const centerMap = (map) => {
      const bounds = new google.maps.LatLngBounds();

      // loop through all markers and create bounds
      $.each(map.markers, (i, marker) => {
        const latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
        bounds.extend(latlng);
      });

      // only 1 marker?
      if (map.markers.length === 1) {
        // set center of map
        map.setCenter(bounds.getCenter());
        map.setZoom(10);
      } else {
        // fit to bounds
        map.fitBounds(bounds);
      }
    };

    loadGoogleMapsApi({
      key: window.sage.google_api_key || '',
    }).then(() => {
      $('.google-map').each((i, elm) => {
        newMap($(elm).find('.google-map__map'));

        // TODO
        // Map wont show with default styles set on element so we remove it
        // DIRTY HACK
        setTimeout(() => {
          $('.google-map').find('.google-map__map').css({
            overflow: 'visible',
            position: 'static',
          });
        }, 1000);
      });
    });
  }
}
